/**
 * Build-time configuration.
 *
 * Create React App inlines `process.env.REACT_APP_*` at build time, so these are
 * baked into the bundle by `react-scripts build` — they are NOT read at runtime.
 * Changing one means rebuilding and redeploying.
 *
 * Both fall back to **production**. A deploy that forgets to set them therefore
 * fails towards production rather than towards dev, which is the opposite of the
 * previous `window.location.hostname === 'register.upsl.com'` sniffing: that sent
 * every host except one literal domain — localhost and the production app's own
 * `herokuapp.com` URL included — to the dev backend.
 *
 * See README.md for the values each Heroku app needs.
 */

const PRODUCTION_DASHBOARD_ORIGIN = 'https://upslregistration.com';

/** Trim whitespace and any trailing slash so callers can concatenate paths safely. */
const normalize = (value: string | undefined, fallback: string): string => {
  const trimmed = (value ?? '').trim().replace(/\/+$/, '');
  return trimmed || fallback;
};

/** Base URL for the Django REST API, e.g. `https://upslregistration.com/api`. */
export const API_BASE_URL = normalize(process.env.REACT_APP_API_BASE_URL, `${PRODUCTION_DASHBOARD_ORIGIN}/api`);

/**
 * Origin of the Django dashboard, with no trailing slash and no `/api` suffix.
 * The sign-in handoff POST and the legacy fallback redirect both target it.
 */
export const DASHBOARD_ORIGIN = normalize(process.env.REACT_APP_DASHBOARD_ORIGIN, PRODUCTION_DASHBOARD_ORIGIN);
